import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import GenderForm from '../../../components/forms/GenderForm';
import { useGenderById, useUpdateGender } from '../../../hooks/useGenderApi';
import { useNavigate, useParams } from 'react-router-dom';
import { GenderDTO } from '../../../services/apiClient';

const GenderEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useGenderById(id!);
  const updateGender = useUpdateGender();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Genders', href: '/admin/genders' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateGender.mutateAsync({ id: id!, data });
      navigate('/admin/genders');
    } catch (error) {
      console.error('Error updating Gender:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/genders"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Gender.Edit'
    >
        {entityData ? (
          <GenderForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/genders')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default GenderEdit;